module.exports = __webpack_public_path__ + "img/9788994340159.45ecb2d9.jpg";